import { createFileRoute } from "@tanstack/react-router";

import CompetitionDetailsForm from "@/components/CompetitionProfile/CompetitionDetailsForm";

const Component = () => {
  const { competitionUuid } = Route.useParams();

  return <CompetitionDetailsForm competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/profile/details")({
  component: Component,
});
